<template>
  <v-container fluid pa-0>
    <!-- Individual Position -->
    <helpers-section-sub-header>Run history for this model.:</helpers-section-sub-header>
    <p>
      The past 10 runs of this model are saved here. You can restore one of the models or use the
      criteria to create a new model.
    </p>
    <v-data-table :headers="snapshot_headers" :items="snapshots" class="mt-6 mb-8">
      <template #top>
        <v-dialog v-model="taDialog" scrollable max-width="450px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Criteria Used:</span>
            </v-card-title>

            <v-card-text style="height: 350px">
              <v-container>
                <v-row density="compact">
                  <p
                    v-if="selectedSnapshot && selectedSnapshot.criteria_view"
                    v-html="selectedSnapshot.criteria_view"
                  />
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <div class="flex-grow-1" />
              <v-btn color="blue-darken-1" text @click="taDialog = false"> Close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template #item.action="{ item }">
        <v-icon small title="View Criteria Used" class="mr-2" @click="view(item)">
          {{ mdiEye }}
        </v-icon>
        <v-icon
          icon
          small
          title="Create New Model Using This Criteria"
          @click="copyTradingModel(item)"
        >
          {{ mdiContentCopy }}
        </v-icon>
        <v-icon icon small title="Revert back to this criteria" @click="revert(item)">
         {{ mdiRestore }}
        </v-icon>
        <v-icon small title="Delete This Snapshot" @click="deleteSnapshot(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template #item.enabled="{ item }">
        <v-switch v-model="item.enabled" color="primary" />
      </template>
      <template #no-data> No Prior Snapshots Exist </template>
    </v-data-table>
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" theme="dark" class="pa-2">
        <v-card-text>
          loading history...
          <v-progress-linear indeterminate color="accent" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'
import api from '@/store/api'
import cloneDeep from 'lodash/cloneDeep'
import axios from 'axios'
import { mdiDelete, mdiEye, mdiRestore,mdiContentCopy,  } from '@mdi/js'
import { useUserStore, useAppStore, useWwStore } from '@/store'
export default {
  inject: ['backtesterLoadTradingModel', 'backtesterRevertBacktest', 'backtesterCloseModel'],

  data: () => ({
    mdiDelete,
    mdiRestore,
    mdiEye,
    mdiContentCopy,
    selectedSnapshot: {},
    friends: [],
    loading: false,
    snapshots: [],
    taDialog: false,
    snapshot_headers: [
      {
        title: 'Date Run',
        align: 'left',
        sortable: true,
        key: 'created_at'
      },
      {
        title: 'Annualized Perf.',
        key: 'annualized_performance',
        sortable: true
      },
      {
        title: 'Perf Ytd',
        key: 'perf_ytd',
        sortable: true
      },
      {
        title: 'Perf All-time',
        key: 'perf_all',
        sortable: true
      },
      { title: 'Actions', key: 'action', sortable: false }
    ]
  }),
  computed: {
    ...mapFields({
      criteria: 'app.whaleTraderCriteria',
      current_trading_model: 'app.current_trading_model'
    })
  },
  watch: {},
  mounted() {
    this.loadSnapshots()
  },

  methods: {
    loadSnapshots() {
      var that = this
      this.snapshots = []
      this.loading = true
      axios
        .get('/dashboard/trading_model_snapshots?id=' + this.current_trading_model.id, {})
        .then(function (response) {
          console.log(response)
          if (response.data) {
            that.snapshots = response.data
          } else {
            useAppStore().showNotification({
              type: 'error',
              text: 'User not found'
            })
          }
        })
        .catch(function (error) {
          console.log(error)
          useAppStore().showNotification({
            type: 'error',
            text: (error.response && error.response.data) || error.message
          })
        })
        .then(function () {
          that.loading = false
        })
    },
    diff(item) {
      this.taDialog = true
    },
    view(item) {
      this.selectedSnapshot = item
      this.taDialog = true
    },
    copyTradingModel(item) {
      var model = cloneDeep(this.current_trading_model)
      this.backtesterCloseModel()
      this.current_trading_model = model
      this.current_trading_model.criteria = item.criteria
      if (
        typeof this.current_trading_model.criteria === 'string' ||
        this.current_trading_model.criteria instanceof String
      ) {
        var criteria = JSON.parse(this.current_trading_model.criteria)
        this.current_trading_model.criteria = criteria
      }
      this.current_trading_model.id = -1
      this.current_trading_model.status = 0
      this.current_trading_model.last_status_description = 'Unsaved'
      this.current_trading_model.last_status_update = ''
      this.current_trading_model.description = 'Copy of ' + this.current_trading_model.description
      useUserStore().tradingModels.push(this.current_trading_model)
      this.snapshots = []
      this.backtesterLoadTradingModel(this.current_trading_model)
    },
    revert(item) {
      // prompt user to confirm that they will lose all current
      if (!window.confirm('Are you sure you want to revert this trading model?')) {
        return
      }
      this.current_trading_model.criteria = item.criteria
      if (
        typeof this.current_trading_model.criteria === 'string' ||
        this.current_trading_model.criteria instanceof String
      ) {
        var criteria = JSON.parse(this.current_trading_model.criteria)
        this.current_trading_model.criteria = criteria
        this.current_trading_model.criteria.resume_from_id = item.id
      }
      this.backtesterLoadTradingModel(this.current_trading_model)
      this.backtesterRevertBacktest()
    },
    deleteSnapshot(model) {
      if (!window.confirm('Are you sure you want to delete this snapshot?')) {
        return
      }
      if (model.id && model.id > 0) {
        api
          .delete(`trading_model_snapshot/${model.id}?${model.id}`)
          .then(() => {
            this.loadSnapshots()

            useAppStore().showNotification({
              type: 'info',
              text: 'snapshot has been deleted'
            })
          })
          .catch(error => {
            useAppStore().showNotification({
              type: 'error',
              text: error.message
            })
          })
      }
    }
  }
}
</script>
